import { Stack, Typography } from '@mui/material';
import { ModalStep, useModalSteps } from 'src/components/ModalContainer';
import { SmartSendConfirmStep } from 'src/pages/Conversations/Chat/InputField/smart-send/smart-send-confirm-step';
import type { SmartSendConflict } from 'src/pages/Conversations/Chat/InputField/smart-send/smart-send-context';
import { SmartSendTimeStep } from 'src/pages/Conversations/Chat/InputField/smart-send/smart-send-time-step';

interface SmartSendConflictStepProps {
  conflict: SmartSendConflict;
}

/** First step when a send is already scheduled: edit that one, or replace it with this message. */
export const SmartSendConflictStep = ({ conflict }: SmartSendConflictStepProps) => {
  const { pushStep } = useModalSteps();
  const { scheduledLabel, previewText, onEditExisting, onReplaceWithNew } = conflict;

  return (
    <ModalStep
      title="Already scheduled"
      actions={[
        {
          label: 'Replace with new',
          kind: 'secondary',
          onClick: () => {
            onReplaceWithNew();
            void pushStep(<SmartSendTimeStep afterPick="confirm" />);
          },
          testId: 'smart-send-conflict-modal-replace',
        },
        {
          label: 'Edit existing',
          kind: 'primary',
          onClick: () => {
            onEditExisting();
            void pushStep(<SmartSendConfirmStep canChangeTime />);
          },
          testId: 'smart-send-conflict-modal-edit',
        },
      ]}
    >
      <Stack gap={2} data-testid="smart-send-conflict">
        <Typography variant="body2">
          There is already a scheduled message for this conversation.
        </Typography>
        <Stack gap={0.5}>
          <Typography variant="caption" color="text.secondary">
            Scheduled for
          </Typography>
          <Typography variant="subtitle2">{scheduledLabel}</Typography>
        </Stack>
        <Stack gap={0.5}>
          <Typography variant="caption" color="text.secondary">
            Preview
          </Typography>
          <Typography variant="body2" whiteSpace="pre-line">
            {previewText || '(no content)'}
          </Typography>
        </Stack>
      </Stack>
    </ModalStep>
  );
};
